import { icon } from "./iconsKit";

/**
 * The paused layer: dims the map and says "Paused — tap to resume". It sits under the HUD plate, the control row and
 * the card tray (inserted before them), so the settings gear and the pause button stay bright and tappable. The layer
 * itself takes no touches: the map under it still pans, pinches and turns, and a tap on the map resumes (the level
 * routes that tap here instead of to the board). The label pill is the one part that is a button.
 */
export class PauseOverlay {
  readonly root: HTMLDivElement;

  constructor(parent: HTMLElement, before: Element | null, onResume: () => void) {
    this.root = document.createElement("div");
    this.root.className = "pause-layer hidden";
    this.root.innerHTML = `<button class="plate resume disp">${icon("play", 20)}<span>PAUSED</span></button>`;
    this.root.querySelector<HTMLButtonElement>(".resume")!.onclick = () => onResume();
    parent.insertBefore(this.root, before && before.parentNode === parent ? before : null);
  }

  get shown(): boolean { return !this.root.classList.contains("hidden"); }
  show(on: boolean): void { this.root.classList.toggle("hidden", !on); }
  dispose(): void { this.root.remove(); }
}

/**
 * Calls `onGone` once, when `el` leaves the document (a sheet closes by removing itself, from any of its buttons).
 * Watches `parent`'s children, which is where the sheets are appended. Returns the stop function.
 */
export function whenRemoved(el: Element, parent: Node, onGone: () => void): () => void {
  if (typeof MutationObserver === "undefined") return () => undefined;
  const o = new MutationObserver(() => { if (!el.isConnected) { o.disconnect(); onGone(); } });
  o.observe(parent, { childList: true });
  return () => o.disconnect();
}
